<script>
    import { _ } from "../services/i18n";

    /**
     * Ejemplo:
     * actions={
     *      "ui_buttons_accept": () => console.log("action 1"),
     *      "ui_buttons_cancel": () => console.log("action 2")
     * }
     * disabled={
     *      "ui_button_accept": false,
     *      "ui_button_cancel": true
     * }
     * labels={
     *      "ui_button_accept": "Vale",
     *      "ui_button_cancel": "Mejor que no"
     * }
     */
    export let actions = {};

    export let disabled = {};

    export let labels = {};

    for (const label in actions) {
        if (!labels[label]) {
            labels[label] = label;
        }
    }
</script>

<div class="action-group test">
    {#each Object.entries(actions) as [text, action] }
        {#if disabled[text]}
            <button disabled>{$_(labels[text])}</button>
        {:else}
            <button on:click={action}>{$_(labels[text])}</button>
        {/if}
    {/each}
</div>

<style>
    .action-group {
        text-align: right;
        padding-top: 5px;
        padding-bottom: 5px;
    }

    button {
        margin-left: 5px; 
        color: white;
        border-radius: 5px;
        background-color: #36a9e1;
        padding: 10px;
        border: #36a9e1;
        letter-spacing: 1.5px;
        font-size: 14px;
        text-transform: uppercase;
      

    }


    button:hover {
        background-color: #1b3258;
        border: #1b3258;
    }

</style>